module.exports = __webpack_public_path__ + "static/media/human-resources-icon-selected.06d07af8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/human-resources-icon-selected.svg
// module id = 1929
// module chunks = 0